export const SELF_ENROLLED_BUILDING_ATTR = 'Self Service';

export const MONTHLY_RENT_SDR_LIMIT_BY_USER_TYPE = {
  SELF_ENROLLED: 1,
  PMI: 3,
};
